import type { AuditableEntity, ID } from './common';
import type { PermissionKey } from './permission';

export const ROLE_KEYS = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  MANAGER: 'manager',
  USER: 'user',
} as const;

export type RoleKey = (typeof ROLE_KEYS)[keyof typeof ROLE_KEYS];

export interface Role extends AuditableEntity {
  id: ID;
  key: RoleKey | string;
  name: string;
  description?: string;
  permissions: PermissionKey[];
  isSystem?: boolean;
}
